import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import {
  Button,
  Form,
  InputGroup,
  Modal,
  Tab,
  Tabs,
  Row,
  Col,
  Card,
  Alert,
  Spinner,
  Badge,
  Container,
} from 'react-bootstrap';
import axios from 'axios';
import './AdminLayout.css';
import BASE_URL, { BACKEND_URL } from '../config';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMapEvents,
  useMap,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';
import {
  FaEdit,
  FaUserCheck,
  FaEye,
  FaTrash,
  FaMapMarkerAlt,
  FaCar,
  FaShareAlt,
  FaQrcode,
  FaLink,
  FaWhatsapp,
  FaEnvelope,
  FaExternalLinkAlt,
  FaBoxOpen,
  FaFileExport,
} from 'react-icons/fa';
import OrderTracking from './OrderTracking';
import DataTable from 'react-data-table-component';
import AdminOrderDetailsModal from './AdminOrderDetailsModal';
import * as XLSX from 'xlsx'; // Import XLSX
import { saveAs } from 'file-saver'; // Import saveAs

// Leaflet Customizations
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const mapContainerStyle = { height: '350px', width: '100%' };
const defaultCenter = [10.5276, 76.2144];

const authAxios = axios.create({ baseURL: BASE_URL });
authAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const uploadAttachment = async (orderId, file, userId, orderStatus) => {
  if (!file) return null;
  const attachableId = Number(orderId);
  if (isNaN(attachableId)) return null;

  const formData = new FormData();
  const typeMap = {
    pending: 'order_pending',
    assigned: 'order_pending',
    accepted: 'order_pending',
    picked_up: 'order_picked_up',
    in_transit: 'order_in_transit',
    delivered: 'order_delivered',
    returned: 'order_returned',
    rejected: 'order_rejected',
    completed: 'order_delivered',
  };
  formData.append(
    'attachable_type',
    typeMap[orderStatus?.toLowerCase()] || 'order_pending'
  );
  formData.append('attachable_id', attachableId);
  formData.append('uploaded_by_id', userId);

  let type = 'order_document';
  if (file.type.startsWith('image/')) type = 'pod_photo';
  else if (file.type.startsWith('audio/')) type = 'voice_note';
  formData.append('type', type);
  formData.append('file', file);

  try {
    const res = await authAxios.post('/attachments', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const AdminOrders = () => {
  const [showNewOrder, setShowNewOrder] = useState(false);
  const [showAssign, setShowAssign] = useState(false);
  const [showEditOrder, setShowEditOrder] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vendors, setVendors] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [search, setSearch] = useState('');
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [selectedDriver, setSelectedDriver] = useState('');
  const [selectedOrderToAssign, setSelectedOrderToAssign] = useState(null);
  const [pendingBalance, setPendingBalance] = useState('');
  const [orderType, setOrderType] = useState('');
  const [driverId, setDriverId] = useState('');
  const [vendorId, setVendorId] = useState('');
  const [poNumber, setPoNumber] = useState('');
  const [vendorAddress, setVendorAddress] = useState('');
  const [dropAddress, setDropAddress] = useState('');
  const [poFile, setPoFile] = useState(null);
  const [poValue, setPoValue] = useState('');
  const [remarks, setRemarks] = useState('');
  const [newFromCoords, setNewFromCoords] = useState(null);
  const [newDropCoords, setNewDropCoords] = useState(null);
  const [showroom, setShowroom] = useState('');
  const [showrooms, setShowrooms] = useState([]);
  const [userId, setUserId] = useState(null);
  const [pickupLat, setPickupLat] = useState('');
  const [pickupLng, setPickupLng] = useState('');
  const [deliveryLat, setDeliveryLat] = useState('');
  const [deliveryLng, setDeliveryLng] = useState('');
  const [poNumbers, setPoNumbers] = useState([]);
  const [selectedPoId, setSelectedPoId] = useState('');
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewOrder, setViewOrder] = useState(null);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  console.log('selectedOrder', selectedOrder);
  const [trackModalOrder, setTrackModalOrder] = useState(null);
  console.log('trackModalOrder', trackModalOrder);
  const [showOrderTrackingModal, setShowOrderTrackingModal] = useState(false);
  const [messageModal, setMessageModal] = useState({
    show: false,
    title: '',
    body: '',
  });
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredShowroomsForDriver, setFilteredShowroomsForDriver] = useState(
    []
  );
  const [filteredShowroomsForEdit, setFilteredShowroomsForEdit] = useState([]);
  console.log('totalRows', totalRows);
  const [perPage, setPerPage] = useState(20);
  const [activeTab, setActiveTab] = useState('pending');
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [lastPage, setLastPage] = useState(1);
  const isFetchingRef = useRef(false);
  const scrollContainerRef = useRef(null);
  const dataTableScrollRef = useRef(null);
  const scrollHandlerRef = useRef(null);
  const hasDataRef = useRef({}); // Track if we've ever had data for each tab
  const showMessageModal = (title, body) =>
    setMessageModal({ show: true, title, body });
  const handleCloseMessageModal = () =>
    setMessageModal({ show: false, title: '', body: '' });

  const handleOpenAttachment = (file) => {
    if (!file.path) return;
    const fileUrl = `${BACKEND_URL}/${file.path}`;
    window.open(fileUrl, '_blank');
  };
  const handleShowOrderModal = (order) => {
    setSelectedOrder(order);
    setShowOrderModal(true);
  };

  const fetchCustomers = async () => {
    try {
      const res = await authAxios.get('/customers');
      setCustomers(res.data?.data?.data || []);
    } catch (err) {
      setCustomers([]);
    }
  };

  const fetchShowrooms = async () => {
    try {
      const res = await authAxios.get('/showrooms');
      setShowrooms(res.data?.data?.data || []);
    } catch (err) {
      setShowrooms([]);
    }
  };

  const fetchPoNumbers = async () => {
    try {
      const res = await authAxios.get('/purchase-orders');
      setPoNumbers(res.data?.data?.data || []);
    } catch (err) {
      setPoNumbers([]);
    }
  };

  const handleCloseOrderModal = () => {
    setShowOrderModal(false);
    setSelectedOrder(null);
  };

  const handlePoSelect = async (selectedPo) => {
    if (!selectedPo) return;
    setSelectedPoId(selectedPo.id);
    setPoNumber(selectedPo.po_number || '');
    if (selectedPo.vendor_id) {
      setVendorId(selectedPo.vendor_id);
      try {
        const res = await authAxios.get(`/vendors/${selectedPo.vendor_id}`);
        const v = res.data?.data;
        if (v) {
          setVendorAddress(v.address || '');
          if (v.lat && v.lng) {
            const lat = parseFloat(v.lat),
              lng = parseFloat(v.lng);
            setPickupLat(lat.toString());
            setPickupLng(lng.toString());
            setNewFromCoords([lat, lng]);
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
    if (selectedPo.showroom_id) {
      setShowroom(selectedPo.showroom_id);
      try {
        const res = await authAxios.get(`/showrooms/${selectedPo.showroom_id}`);
        const s = res.data?.data;
        if (s) {
          setDropAddress(s.address || '');
          if (s.lat && s.lng) {
            const lat = parseFloat(s.lat),
              lng = parseFloat(s.lng);
            setDeliveryLat(lat.toString());
            setDeliveryLng(lng.toString());
            setNewDropCoords([lat, lng]);
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
    if (selectedPo.value) setPoValue(selectedPo.value);
  };

  const handleVendorSelect = async (selectedVendor) => {
    if (!selectedVendor) return;
    setVendorId(selectedVendor.id);
    setVendorAddress(selectedVendor.address || '');
    if (selectedVendor.lat && selectedVendor.lng) {
      const lat = parseFloat(selectedVendor.lat),
        lng = parseFloat(selectedVendor.lng);
      setPickupLat(lat.toString());
      setPickupLng(lng.toString());
      setNewFromCoords([lat, lng]);
    }
  };

  const handleShowroomSelect = async (selectedShowroom) => {
    if (!selectedShowroom) return;
    setShowroom(selectedShowroom.id);
    setDropAddress(selectedShowroom.address || '');
    if (selectedShowroom.lat && selectedShowroom.lng) {
      const lat = parseFloat(selectedShowroom.lat),
        lng = parseFloat(selectedShowroom.lng);
      setDeliveryLat(lat.toString());
      setDeliveryLng(lng.toString());
      setNewDropCoords([lat, lng]);
    }
  };

  const handleCustomerSelect = async (selectedCustomer) => {
    if (!selectedCustomer) return;
    setCustomerId(selectedCustomer.id);
    try {
      const res = await authAxios.get(
        `/orders?customer_id=${selectedCustomer.id}`
      );
      const orders = res.data?.data?.data || [];
      if (orders.length > 0) {
        const recent = orders[0];
        setVendorAddress(recent.pickup_address || '');
        setDropAddress(recent.delivery_address || '');
        if (recent.pickup_lat && recent.pickup_lng) {
          setPickupLat(recent.pickup_lat);
          setPickupLng(recent.pickup_lng);
        }
        if (recent.delivery_lat && recent.delivery_lng) {
          setDeliveryLat(recent.delivery_lat);
          setDeliveryLng(recent.delivery_lng);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmitOrder = async (e) => {
    e.preventDefault();
    if (!orderType) {
      showMessageModal('Warning', 'Please select a valid order type.');
      return;
    }
    try {
      const pickupLatValue = pickupLat
        ? parseFloat(pickupLat)
        : newFromCoords?.[0] || null;
      const pickupLngValue = pickupLng
        ? parseFloat(pickupLng)
        : newFromCoords?.[1] || null;
      const deliveryLatValue = deliveryLat
        ? parseFloat(deliveryLat)
        : newDropCoords?.[0] || null;
      const deliveryLngValue = deliveryLng
        ? parseFloat(deliveryLng)
        : newDropCoords?.[1] || null;
      const payload = {
        type: orderType,
        customer_id: customerId ? Number(customerId) : null,
        vendor_id: vendorId ? Number(vendorId) : null,
        // Don't include driver_id in initial creation - will assign separately if driver is selected
        showroom_id: showroom ? Number(showroom) : null,
        pickup_address: vendorAddress,
        delivery_address: dropAddress,
        po_number: poNumber,
        invoice_number: invoiceNumber,
        pending_balance: pendingBalance ? Number(pendingBalance) : 0,
        return_value: poValue ? Number(poValue) : 0,
        notes: remarks,
        proof_required: poFile ? true : false,
        pickup_lat: pickupLatValue,
        pickup_lng: pickupLngValue,
        delivery_lat: deliveryLatValue,
        delivery_lng: deliveryLngValue,
      };
      const orderRes = await authAxios.post('/orders', payload);
      const orderId = orderRes.data?.data?.id;

      if (poFile) await uploadAttachment(orderId, poFile, userId, 'pending');

      // If driver is selected, assign driver using the assign driver API
      if (driverId && orderId) {
        try {
          await authAxios.post(`/orders/${orderId}/assign-driver`, {
            driver_id: Number(driverId),
          });
        } catch (assignErr) {
          console.error('Error assigning driver:', assignErr);
          // Show warning but don't fail the entire order creation
          showMessageModal(
            'Warning',
            'Order created successfully, but driver assignment failed. Please assign driver manually.'
          );
          // Still continue with success flow
          setShowNewOrder(false);
          resetNewOrderForm();
          // Reset and reload orders from the beginning
          setOrders([]);
          setCurrentPage(1);
          setHasMore(true);
          const statusFilter = getStatusFilterForTab(activeTab);
          fetchAllOrdersSequentially(statusFilter, activeTab);
          return;
        }
      }

      const successMessage = driverId
        ? 'Order created and driver assigned successfully!'
        : 'Order created successfully!';
      showMessageModal('Success', successMessage);
      setShowNewOrder(false);
      resetNewOrderForm();
      // Reset and reload orders from the beginning
      setOrders([]);
      setCurrentPage(1);
      setHasMore(true);
      const statusFilter = getStatusFilterForTab(activeTab);
      fetchAllOrdersSequentially(statusFilter, activeTab);
    } catch (err) {
      const msg = err.response?.data?.error || 'Unknown error';
      showMessageModal('Error', `Order creation failed: ${msg}`);
    }
  };

  const resetNewOrderForm = () => {
    setOrderType('');
    setDriverId('');
    setVendorId('');
    setCustomerId('');
    setPoNumber('');
    setInvoiceNumber('');
    setPendingBalance('');
    setPoValue('');
    setRemarks('');
    setShowroom('');
    setVendorAddress('');
    setDropAddress('');
    setPoFile(null);
    setNewFromCoords(null);
    setNewDropCoords(null);
    setPickupLat('');
    setPickupLng('');
    setDeliveryLat('');
    setDeliveryLng('');
    setSelectedPoId('');
  };

  const handleDeleteOrder = async (orderId) => {
    if (!window.confirm('Are you sure you want to delete this order?')) return;
    try {
      await authAxios.delete(`/orders/${orderId}`);
      showMessageModal('Success', 'Order deleted successfully!');
      // Reset and reload orders from the beginning
      setOrders([]);
      setCurrentPage(1);
      setHasMore(true);
      const statusFilter = getStatusFilterForTab(activeTab);
      fetchAllOrdersSequentially(statusFilter, activeTab);
    } catch (err) {
      const msg = err.response?.data?.error || 'Unknown error';
      showMessageModal('Error', `Failed to delete order: ${msg}`);
    }
  };

  const handleEditSubmit = async (editedOrder, poFile) => {
    try {
      const payload = {
        ...editedOrder,
        customer_id: editedOrder.customer_id
          ? Number(editedOrder.customer_id)
          : null,
        vendor_id: editedOrder.vendor_id ? Number(editedOrder.vendor_id) : null,
        driver_id: editedOrder.driver_id ? Number(editedOrder.driver_id) : null,
        showroom_id: editedOrder.showroom_id
          ? Number(editedOrder.showroom_id)
          : null,
        pending_balance: editedOrder.pending_balance
          ? Number(editedOrder.pending_balance)
          : 0,
        return_value: editedOrder.return_value
          ? Number(editedOrder.return_value)
          : 0,
        proof_required: poFile ? true : false,
      };
      await authAxios.patch(`/orders/${editedOrder.id}`, payload);
      if (poFile)
        await uploadAttachment(
          editedOrder.id,
          poFile,
          userId,
          editedOrder.status
        );
      showMessageModal('Success', 'Order updated successfully!');
      setShowEditOrder(false);
      setCurrentOrder(null);
      // Reset and reload orders from the beginning
      setOrders([]);
      setCurrentPage(1);
      setHasMore(true);
      const statusFilter = getStatusFilterForTab(activeTab);
      fetchAllOrdersSequentially(statusFilter, activeTab);
    } catch (err) {
      const msg = err.response?.data?.error || 'Unknown error';
      showMessageModal('Error', `Order update failed: ${msg}`);
    }
  };

  // Fetch single page of orders
  const fetchOrdersPage = async (
    page,
    rowsPerPage,
    statusFilter,
    activeTab
  ) => {
    try {
      const userShowroomId = localStorage.getItem('userShowroomId');
      const params = {
        per_page: rowsPerPage,
      };

      // Handle status filter based on active tab
      if (statusFilter) {
        params.status = statusFilter;
      } else {
        if (activeTab === 'pending') {
          params.status = 'pending';
        } else if (activeTab === 'intransit') {
          params.status = 'in_transit';
        }
        // For history tab, don't set status to fetch all orders
      }

      const res = await authAxios.get(`/orders?page=${page}`, {
        params,
      });

      const responseData = res.data?.data || res.data;
      const ordersData = Array.isArray(responseData?.data)
        ? responseData.data
        : Array.isArray(responseData)
        ? responseData
        : [];

      // Get pagination metadata
      const lastPage = responseData?.last_page ?? res.data?.last_page;
      const currentPageNum = responseData?.current_page ?? page;
      const total = responseData?.total ?? res.data?.total;

      return {
        ordersData,
        lastPage,
        currentPageNum,
        total,
        hasMore: lastPage
          ? currentPageNum < lastPage
          : ordersData.length === rowsPerPage,
      };
    } catch (err) {
      console.error(`Error fetching orders page ${page}:`, err);
      throw err;
    }
  };

  // Fetch all orders page by page until last page
  const fetchAllOrdersSequentially = async (statusFilter, activeTab) => {
    // Prevent multiple simultaneous calls
    if (isFetchingRef.current) {
      return;
    }
    isFetchingRef.current = true;
    setLoading(true);
    setOrders([]);
    setCurrentPage(1);
    setHasMore(true);
    // Reset the hasDataRef for the current tab when starting a new fetch
    if (activeTab) {
      hasDataRef.current[activeTab] = false;
    }

    try {
      let page = 1;
      let allOrdersList = [];
      let lastPageNum = null;
      let totalCount = 0;

      // Fetch first page to get total and last page info
      const firstPageData = await fetchOrdersPage(
        page,
        perPage,
        statusFilter,
        activeTab
      );
      lastPageNum = firstPageData.lastPage;
      totalCount = firstPageData.total || 0;

      // Map attachments for first page
      const mappedFirstPageOrders = firstPageData.ordersData.map((order) => {
        const attachments = Array.isArray(
          order.attachments?.data ? order.attachments.data : order.attachments
        )
          ? order.attachments?.data || order.attachments
          : [];
        const pod_photos = attachments.filter(
          (a) => a.type?.toLowerCase() === 'pod_photo'
        );
        const voice_notes = attachments.filter(
          (a) => a.type?.toLowerCase() === 'voice_note'
        );
        const order_docs = attachments.filter(
          (a) => a.type?.toLowerCase() === 'order_document'
        );

        return {
          ...order,
          customer_name:
                  order.customer?.name 
                    ? order.customer?.name : order.customer_id ? `Customer #${order.customer_id}` : undefined,
                vendor_name:
                  order.vendor?.name 
                    ? order.vendor?.name
                    : order.vendor_id ? `Vendor #${order.vendor_id}` : undefined,
                driver_name:
                  order.driver?.name 
                    ? order.driver?.name
                    : order.driver_id ? `Driver #${order.driver_id}` : 'Unassigned',
          showroom_name: order.showroom?.name || order.showroom_name || 'N/A',
          order_number: order.po_number || order.order_number || order.id,
          attachments: {
            pod_photos: (Array.isArray(pod_photos) ? pod_photos : []).map(
              (a) => ({
                ...a,
                url: a.path ? `${BACKEND_URL}/${a.path}` : null,
              })
            ),
            voice_notes: (Array.isArray(voice_notes) ? voice_notes : []).map(
              (a) => ({
                ...a,
                url: a.path ? `${BACKEND_URL}/${a.path}` : null,
              })
            ),
            order_docs: (Array.isArray(order_docs) ? order_docs : []).map(
              (a) => ({
                ...a,
                url: a.path ? `${BACKEND_URL}/${a.path}` : null,
              })
            ),
          },
        };
      });

      // Initialize allOrdersList with first page data
      allOrdersList = [...mappedFirstPageOrders];

      // Update state with first page data - use allOrdersList for consistency
      setOrders(allOrdersList.map((order) => ({ ...order })));
      setCurrentPage(page);
      setLastPage(lastPageNum || 1);
      setTotalRows(totalCount || mappedFirstPageOrders.length);

      // Set loading to false after first page is loaded so data is visible
      // Use isLoadingMore for subsequent pages
      setLoading(false);

      // If there are more pages, fetch them sequentially
      if (firstPageData.hasMore && lastPageNum) {
        setIsLoadingMore(true);
        for (page = 2; page <= lastPageNum; page++) {
          try {
            const pageData = await fetchOrdersPage(
              page,
              perPage,
              statusFilter,
              activeTab
            );
            const newOrders = pageData.ordersData.map((order) => {
              const attachments = Array.isArray(
                order.attachments?.data
                  ? order.attachments.data
                  : order.attachments
              )
                ? order.attachments?.data || order.attachments
                : [];
              const pod_photos = attachments.filter(
                (a) => a.type?.toLowerCase() === 'pod_photo'
              );
              const voice_notes = attachments.filter(
                (a) => a.type?.toLowerCase() === 'voice_note'
              );
              const order_docs = attachments.filter(
                (a) => a.type?.toLowerCase() === 'order_document'
              );

              return {
                ...order,
                customer_name:
                  order.customer?.name 
                    ? order.customer?.name : order.customer_id ? `Customer #${order.customer_id}` : undefined,
                vendor_name:
                  order.vendor?.name 
                    ? order.vendor?.name
                    : order.vendor_id ? `Vendor #${order.vendor_id}` : undefined,
                driver_name:
                  order.driver?.name 
                    ? order.driver?.name
                    : order.driver_id ? `Driver #${order.driver_id}` : 'Unassigned',
                showroom_name:
                  order.showroom?.name || order.showroom_name || 'N/A',
                order_number: order.po_number || order.order_number || order.id,
                attachments: {
                  pod_photos: (Array.isArray(pod_photos) ? pod_photos : []).map(
                    (a) => ({
                      ...a,
                      url: a.path ? `${BACKEND_URL}/${a.path}` : null,
                    })
                  ),
                  voice_notes: (Array.isArray(voice_notes)
                    ? voice_notes
                    : []
                  ).map((a) => ({
                    ...a,
                    url: a.path ? `${BACKEND_URL}/${a.path}` : null,
                  })),
                  order_docs: (Array.isArray(order_docs) ? order_docs : []).map(
                    (a) => ({
                      ...a,
                      url: a.path ? `${BACKEND_URL}/${a.path}` : null,
                    })
                  ),
                },
              };
            });

            // Add new orders to the list, but deduplicate by order ID to prevent duplicates
            const existingIds = new Set(allOrdersList.map((o) => o.id));
            const uniqueNewOrders = newOrders.filter(
              (o) => !existingIds.has(o.id)
            );
            allOrdersList = [...allOrdersList, ...uniqueNewOrders];

            // Update state progressively as each page is fetched
            // Create a completely fresh array with fresh object references
            // This ensures React detects the change and all mapped fields are preserved
            // Use all accumulated orders - don't slice during progressive updates
            // The totalCount is for display purposes only
            const freshOrdersList = Array.from(allOrdersList, (order) => ({
              ...order,
              // Explicitly ensure all mapped fields are present
              customer_name:
                  order.customer?.name 
                    ? order.customer?.name : order.customer_id ? `Customer #${order.customer_id}` : undefined,
                vendor_name:
                  order.vendor?.name 
                    ? order.vendor?.name
                    : order.vendor_id ? `Vendor #${order.vendor_id}` : undefined,
                driver_name:
                  order.driver?.name 
                    ? order.driver?.name
                    : order.driver_id ? `Driver #${order.driver_id}` : 'Unassigned',
              showroom_name:
                order.showroom_name ||
                (order.showroom?.name ? order.showroom.name : 'N/A'),
              order_number: order.order_number || order.po_number || order.id,
            }));
            // Use functional update to ensure we preserve all data during state updates
            // Always merge by ID to prevent losing orders that match current tab filter
            setOrders((prevOrders) => {
              // Create a map of new orders by ID for quick lookup
              const newOrdersMap = new Map(
                freshOrdersList.map((o) => [o.id, o])
              );
              // Get all unique orders: new orders + any previous orders not in new list
              const mergedOrders = [
                ...freshOrdersList,
                ...prevOrders.filter((o) => !newOrdersMap.has(o.id)),
              ];
              return mergedOrders;
            });
            setCurrentPage(page);

            console.log(
              `Fetched page ${page} of ${lastPageNum}, total orders in state: ${
                freshOrdersList.length
              }, allOrdersList: ${allOrdersList.length}, pageData orders: ${
                pageData.ordersData.length
              }, status filter: ${statusFilter || 'none'}, returned orders: ${
                freshOrdersList.filter(
                  (o) => o.status?.toLowerCase() === 'returned'
                ).length
              }`
            );
          } catch (err) {
            console.error(`Error fetching page ${page}:`, err);
            // Continue with next page even if one fails
          }
        }
      } else if (firstPageData.hasMore && !lastPageNum) {
        // If we don't have last_page info, continue fetching until we get an empty page
        setIsLoadingMore(true);
        page = 2;
        while (true) {
          try {
            const pageData = await fetchOrdersPage(
              page,
              perPage,
              statusFilter,
              activeTab
            );
            if (pageData.ordersData.length === 0) {
              break;
            }

            const newOrders = pageData.ordersData.map((order) => {
              const attachments = Array.isArray(
                order.attachments?.data
                  ? order.attachments.data
                  : order.attachments
              )
                ? order.attachments?.data || order.attachments
                : [];
              const pod_photos = attachments.filter(
                (a) => a.type?.toLowerCase() === 'pod_photo'
              );
              const voice_notes = attachments.filter(
                (a) => a.type?.toLowerCase() === 'voice_note'
              );
              const order_docs = attachments.filter(
                (a) => a.type?.toLowerCase() === 'order_document'
              );

              return {
                ...order,
                customer_name:
                  order.customer?.name || order.customer_id
                    ? `Customer #${order.customer_id}`
                    : 'N/A',
                vendor_name:
                  order.vendor?.name || order.vendor_id
                    ? `Vendor #${order.vendor_id}`
                    : 'N/A',
                driver_name:
                  order.driver?.name || order.driver_id
                    ? `Driver #${order.driver_id}`
                    : 'Unassigned',
                showroom_name:
                  order.showroom?.name || order.showroom_name || 'N/A',
                order_number: order.po_number || order.order_number || order.id,
                attachments: {
                  pod_photos: (Array.isArray(pod_photos) ? pod_photos : []).map(
                    (a) => ({
                      ...a,
                      url: a.path ? `${BACKEND_URL}/${a.path}` : null,
                    })
                  ),
                  voice_notes: (Array.isArray(voice_notes)
                    ? voice_notes
                    : []
                  ).map((a) => ({
                    ...a,
                    url: a.path ? `${BACKEND_URL}/${a.path}` : null,
                  })),
                  order_docs: (Array.isArray(order_docs) ? order_docs : []).map(
                    (a) => ({
                      ...a,
                      url: a.path ? `${BACKEND_URL}/${a.path}` : null,
                    })
                  ),
                },
              };
            });

            // Add new orders to the list, but deduplicate by order ID to prevent duplicates
            const existingIds = new Set(allOrdersList.map((o) => o.id));
            const uniqueNewOrders = newOrders.filter(
              (o) => !existingIds.has(o.id)
            );
            allOrdersList = [...allOrdersList, ...uniqueNewOrders];

            // Create a completely fresh array with fresh object references
            // This ensures React detects the change and all mapped fields are preserved
            // Use all accumulated orders - don't slice during progressive updates
            // The totalCount is for display purposes only
            const freshOrdersList = Array.from(allOrdersList, (order) => ({
              ...order,
              // Explicitly ensure all mapped fields are present
              customer_name:
                  order.customer?.name 
                    ? order.customer?.name : order.customer_id ? `Customer #${order.customer_id}` : undefined,
                vendor_name:
                  order.vendor?.name 
                    ? order.vendor?.name
                    : order.vendor_id ? `Vendor #${order.vendor_id}` : undefined,
                driver_name:
                  order.driver?.name 
                    ? order.driver?.name
                    : order.driver_id ? `Driver #${order.driver_id}` : 'Unassigned',
              showroom_name:
                order.showroom_name ||
                (order.showroom?.name ? order.showroom.name : 'N/A'),
              order_number: order.order_number || order.po_number || order.id,
            }));
            // Use functional update to ensure we preserve all data during state updates
            // Always merge by ID to prevent losing orders that match current tab filter
            setOrders((prevOrders) => {
              // Create a map of new orders by ID for quick lookup
              const newOrdersMap = new Map(
                freshOrdersList.map((o) => [o.id, o])
              );
              // Get all unique orders: new orders + any previous orders not in new list
              const mergedOrders = [
                ...freshOrdersList,
                ...prevOrders.filter((o) => !newOrdersMap.has(o.id)),
              ];
              return mergedOrders;
            });
            setCurrentPage(page);

            if (pageData.ordersData.length < perPage) {
              break;
            }
            page++;
          } catch (err) {
            console.error(`Error fetching page ${page}:`, err);
            break;
          }
        }
      }

      setHasMore(false);
      setLastPage(page);
      // Ensure totalRows matches the API total, not the accumulated count
      // The API total is the authoritative source
      if (totalCount > 0) {
        setTotalRows(totalCount);
      } else {
        setTotalRows(allOrdersList.length);
      }
      console.log(
        `Finished fetching all orders. API Total: ${totalCount}, Accumulated: ${allOrdersList.length}`
      );
    } catch (err) {
      console.error('Error fetching all orders:', err);
      setOrders([]);
    } finally {
      setLoading(false);
      setIsLoadingMore(false);
      isFetchingRef.current = false;
    }
  };

  const fetchVendors = async () => {
    try {
      const res = await authAxios.get('/vendors');
      setVendors(Array.isArray(res.data?.data?.data) ? res.data.data.data : []);
    } catch (err) {
      setVendors([]);
    }
  };

  const fetchDrivers = async () => {
    try {
      const allDrivers = [];
      let page = 1;
      const maxPages = 200; // safety cap to avoid infinite loops

      while (page <= maxPages) {
        try {
          const res = await authAxios.get('/drivers', {
            params: { page, per_page: 20 },
          });
          const body = res.data;

          // Normalize to an array of drivers from possible response shapes
          let pageDrivers = [];
          if (body?.data?.data) pageDrivers = body.data.data;
          else if (Array.isArray(body?.data)) pageDrivers = body.data;
          else if (Array.isArray(body)) pageDrivers = body;

          if (!Array.isArray(pageDrivers)) pageDrivers = [];

          allDrivers.push(...pageDrivers);

          // If paginator meta exists, use it to stop
          const meta = body?.data?.meta;
          if (meta) {
            // Check if we've reached the total count or last page
            if (meta.current_page >= meta.last_page) break;
            if (allDrivers.length >= meta.total) break;
            page = meta.current_page + 1;
            continue;
          }

          // If response has total and we've reached it, stop
          if (body?.data?.total && allDrivers.length >= body.data.total) break;

          // If no meta, stop when the current page returned fewer than expected items
          if (pageDrivers.length === 0) break;
          // Heuristic: if fewer than 20 items, likely last page
          if (pageDrivers.length < 20) break;

          page += 1;
        } catch (err) {
          console.error('Error fetching drivers page:', err);
          break;
        }
      }

      setDrivers(allDrivers);
    } catch (err) {
      console.error('Error fetching drivers:', err);
      setDrivers([]);
    }
  };

  const handleTrackDriver = (order) => {
    setTrackModalOrder(order);
    setShowOrderTrackingModal(true);
  };

  const handleCloseTrackModal = () => {
    setShowOrderTrackingModal(false);
    setTrackModalOrder(null);
  };

  // --- EXPORT TO EXCEL FUNCTION ---
  const exportToExcel = () => {
    // Prepare data for export, mapping nested fields and formatting columns
    const dataToExport = filteredOrders.map((order) => ({
      'Order ID': order.id,
      'Order No.': order.order_number,
      Type: order.type ? order.type.toLowerCase().replace(/_/g, ' ') : '',
      Status: order.status
        ? order.status.toLowerCase().replace(/_/g, ' ')
        : 'pending',
      'Customer Name': order.customer_name,
      'Vendor Name': order.vendor_name,
      'Driver Name': order.driver_name,
      'Showroom Name': order.showroom_name,
      'Pickup Address': order.pickup_address,
      'Drop Address': order.drop_address,
      'PO Number': order.po_number,
      'Invoice Number': order.invoice_number,
      'Pending Balance': order.pending_balance,
      'Return Value': order.return_value,
      Remarks: order.notes,
      'Created At': formatDateTime(order.created_at),
      'Updated At': formatDateTime(order.updated_at),
      'Pickup Lat': order.pickup_lat,
      'Pickup Lng': order.pickup_lng,
      'Delivery Lat': order.delivery_lat,
      'Delivery Lng': order.delivery_lng,
    }));

    // Convert JSON to worksheet
    const ws = XLSX.utils.json_to_sheet(dataToExport);

    // Create workbook and append sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Orders');

    // Write file and trigger download
    XLSX.writeFile(wb, 'orders_data.xlsx');
  };
  // ---------------------------------

  useEffect(() => {
    // Only fetch supporting data on mount, not orders
    // Orders will be fetched when a tab is selected
    fetchVendors();
    fetchDrivers();
    fetchCustomers();
    fetchShowrooms();
    fetchPoNumbers();
    const fetchUserId = async () => {
      try {
        const res = await authAxios.get('/user');
        setUserId(res.data.id);
      } catch (err) {
        console.error(err);
      }
    };
    fetchUserId();
  }, []);

  // Fetch orders when activeTab changes
  // This ensures orders are only fetched when a tab is selected
  useEffect(() => {
    // Skip if activeTab is not set
    if (!activeTab) return;

    // Reset fetching ref to allow new fetch when tab changes
    isFetchingRef.current = false;
    // Clear orders immediately to prevent showing wrong data
    setOrders([]);
    setLoading(true);
    setCurrentPage(1);
    setHasMore(true);

    // Use setTimeout to ensure state is cleared before fetching
    const timeoutId = setTimeout(() => {
      const statusFilter = getStatusFilterForTab(activeTab);
      fetchAllOrdersSequentially(statusFilter, activeTab);
    }, 0);

    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // Effect to filter showrooms based on the selected driver in the "New Order" modal
  useEffect(() => {
    if (driverId) {
      const selectedDriverObj = drivers.find(
        (d) => d.id === parseInt(driverId)
      );

      if (selectedDriverObj) {
        // Handle cases where showroom_id can be a JSON string, an array, or a single number
        let driverShowroomIds = [];
        if (Array.isArray(selectedDriverObj.showroom_id)) {
          driverShowroomIds = selectedDriverObj.showroom_id;
        } else if (typeof selectedDriverObj.showroom_id === 'string') {
          try {
            const parsedIds = JSON.parse(selectedDriverObj.showroom_id);
            if (Array.isArray(parsedIds)) {
              driverShowroomIds = parsedIds;
            }
          } catch (e) {
            console.error('Failed to parse showroom_id string:', e);
          }
        } else if (typeof selectedDriverObj.showroom_id === 'number') {
          driverShowroomIds = [selectedDriverObj.showroom_id];
        }
        const numericDriverShowroomIds = driverShowroomIds.map(Number);
        setFilteredShowroomsForDriver(
          showrooms.filter((s) => numericDriverShowroomIds.includes(s.id))
        );
      } else {
        setFilteredShowroomsForDriver([]); // Driver not found
      }
    } else {
      setFilteredShowroomsForDriver(showrooms); // If no driver is selected, show all showrooms
    }
  }, [driverId, drivers, showrooms]);

  // Effect to filter showrooms based on the selected driver in the "Edit Order" modal
  useEffect(() => {
    if (currentOrder?.driver_id) {
      const selectedDriverObj = drivers.find(
        (d) => d.id === parseInt(currentOrder.driver_id)
      );

      if (selectedDriverObj) {
        // Handle cases where showroom_id can be a JSON string, an array, or a single number
        let driverShowroomIds = [];
        if (Array.isArray(selectedDriverObj.showroom_id)) {
          driverShowroomIds = selectedDriverObj.showroom_id;
        } else if (typeof selectedDriverObj.showroom_id === 'string') {
          try {
            const parsedIds = JSON.parse(selectedDriverObj.showroom_id);
            if (Array.isArray(parsedIds)) {
              driverShowroomIds = parsedIds;
            }
          } catch (e) {
            console.error('Failed to parse showroom_id string:', e);
          }
        } else if (typeof selectedDriverObj.showroom_id === 'number') {
          driverShowroomIds = [selectedDriverObj.showroom_id];
        }
        const numericDriverShowroomIds = driverShowroomIds.map(Number);
        setFilteredShowroomsForEdit(
          showrooms.filter((s) => numericDriverShowroomIds.includes(s.id))
        );

        // Automatically set showroom if not set or invalid
        if (numericDriverShowroomIds.length > 0) {
          const currentShowroomId = currentOrder.showroom_id
            ? parseInt(currentOrder.showroom_id)
            : null;

          // If no showroom is set, or current showroom doesn't belong to driver, set it
          if (
            !currentShowroomId ||
            !numericDriverShowroomIds.includes(currentShowroomId)
          ) {
            // Only update if the showroom actually needs to change
            const newShowroomId = numericDriverShowroomIds[0].toString();
            if (currentOrder.showroom_id !== newShowroomId) {
              setCurrentOrder({
                ...currentOrder,
                showroom_id: newShowroomId,
              });
            }
          }
        }
      } else {
        setFilteredShowroomsForEdit([]); // Driver not found
      }
    } else {
      setFilteredShowroomsForEdit(showrooms); // If no driver is selected, show all showrooms
    }
  }, [currentOrder?.driver_id, drivers, showrooms]);

  console.log('orders', orders);
  const filteredOrders = useMemo(() => {
    const q = (search || '').toString().trim().toLowerCase();
    // First filter by active tab status to ensure only correct status orders are shown
    let statusFilteredOrders = orders.filter((order) => {
      if (!activeTab || activeTab === 'history') return true; // History shows all

      const orderStatus = order.status?.toLowerCase();
      switch (activeTab) {
        case 'pending':
          return orderStatus === 'pending';
        case 'assigned':
          return orderStatus === 'assigned';
        case 'accepted':
          return orderStatus === 'accepted';
        case 'intransit':
          return orderStatus === 'in_transit' || orderStatus === 'picked_up';
        case 'completed':
          return orderStatus === 'delivered';
        case 'rejected':
          return orderStatus === 'rejected';
        case 'returned':
          return orderStatus === 'returned';
        default:
          return true;
      }
    });

    // Keep only orders that have an order_number (check for null, undefined, or empty)
    // Also normalize attachments structure for all orders
    const base = statusFilteredOrders
      .filter((order) => {
        // Check if order_number exists (could be po_number, order_number, or id)
        const orderNumber = order.order_number || order.po_number || order.id;
        return orderNumber != null && orderNumber !== '';
      })
      .map((order) => {
        // Ensure attachments structure exists and is properly formatted
        if (!order.attachments || typeof order.attachments !== 'object') {
          return {
            ...order,
            attachments: {
              pod_photos: [],
              voice_notes: [],
              order_docs: [],
            },
          };
        }
        // Ensure all attachment arrays exist and are arrays
        return {
          ...order,
          attachments: {
            pod_photos: Array.isArray(order.attachments.pod_photos)
              ? order.attachments.pod_photos
              : [],
            voice_notes: Array.isArray(order.attachments.voice_notes)
              ? order.attachments.voice_notes
              : [],
            order_docs: Array.isArray(order.attachments.order_docs)
              ? order.attachments.order_docs
              : [],
          },
        };
      });
    if (!q) return base;

    return base.filter((order) => {
      // Check numeric/string order number
      if (
        order.order_number &&
        String(order.order_number).toLowerCase().includes(q)
      )
        return true;

      // Fields to search
      const fields = [
        order.customer_name,
        order.vendor_name,
        order.driver_name,
        order.showroom_name,
        order.type,
        order.status,
        order.po_number,
        order.invoice_number,
        order.pickup_address,
        order.delivery_address,
        order.notes,
      ];

      for (let f of fields) {
        if (f && String(f).toLowerCase().includes(q)) return true;
      }

      // Search attachments (filename or url)
      if (order.attachments) {
        const files = [
          ...(Array.isArray(order.attachments.pod_photos)
            ? order.attachments.pod_photos
            : []),
          ...(Array.isArray(order.attachments.voice_notes)
            ? order.attachments.voice_notes
            : []),
          ...(Array.isArray(order.attachments.order_docs)
            ? order.attachments.order_docs
            : []),
        ];
        for (let a of files) {
          if (a?.name && String(a.name).toLowerCase().includes(q)) return true;
          if (a?.url && String(a.url).toLowerCase().includes(q)) return true;
        }
      }

      return false;
    });
  }, [orders, search, activeTab]);
  console.log('filteredOrders', filteredOrders);
  // Map tab keys to status filters for API
  const getStatusFilterForTab = (tabKey) => {
    switch (tabKey) {
      case 'pending':
        return null; // Special case: pending or no driver_id - handled separately
      case 'assigned':
        return 'assigned';
      case 'accepted':
        return 'accepted';
      case 'intransit':
        return null; // Special case: in_transit or picked_up - handled separately
      case 'completed':
        return 'delivered';
      case 'rejected':
        return 'rejected';
      case 'returned':
        return 'returned';
      case 'history':
        return null; // Show all
      default:
        return null;
    }
  };

  // Removed Intersection Observer - now fetching all pages sequentially

  const getNewOrderFields = () => {
    switch (orderType) {
      case 'purchase_order':
        return (
          <>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='selectVendor'>
                  <Form.Label>Vendor</Form.Label>
                  <Form.Select
                    value={vendorId}
                    onChange={(e) => {
                      setVendorId(e.target.value);
                      const v = vendors.find(
                        (vv) => vv.id === parseInt(e.target.value)
                      );
                      handleVendorSelect(v);
                    }}
                  >
                    <option value=''>Select Vendor</option>
                    {vendors.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId='poNumber'>
                  <Form.Label>PO #</Form.Label>
                  <Form.Control
                    type='text'
                    value={poNumber}
                    onChange={(e) => setPoNumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className='mb-3' controlId='poValue'>
              <Form.Label>PO Value</Form.Label>
              <Form.Control
                type='number'
                value={poValue}
                onChange={(e) => setPoValue(e.target.value)}
              />
            </Form.Group>
            <Form.Group className='mb-3' controlId='attachPO'>
              <Form.Label>Attach PO</Form.Label>
              <Form.Control
                type='file'
                accept='image/*,application/pdf'
                onChange={(e) => setPoFile(e.target.files[0])}
              />
            </Form.Group>
          </>
        );
      case 'purchase_return':
        return (
          <>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='selectVendor'>
                  <Form.Label>Vendor</Form.Label>
                  <Form.Select
                    value={vendorId}
                    onChange={(e) => {
                      setVendorId(e.target.value);
                      const v = vendors.find(
                        (vv) => vv.id === parseInt(e.target.value)
                      );
                      handleVendorSelect(v);
                    }}
                  >
                    <option value=''>Select Vendor</option>
                    {vendors.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId='poNumber'>
                  <Form.Label>PO #</Form.Label>
                  <Form.Select
                    value={selectedPoId}
                    onChange={(e) => {
                      const po = poNumbers.find(
                        (p) => p.id === parseInt(e.target.value)
                      );
                      handlePoSelect(po);
                    }}
                  >
                    <option value=''>Select PO</option>
                    {poNumbers.map((po) => (
                      <option key={po.id} value={po.id}>
                        {po.po_number}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className='mb-3' controlId='poValue'>
              <Form.Label>PO Value</Form.Label>
              <Form.Control
                type='number'
                value={poValue}
                onChange={(e) => setPoValue(e.target.value)}
              />
            </Form.Group>
            <Form.Group className='mb-3' controlId='attachPO'>
              <Form.Label>Attach PO</Form.Label>
              <Form.Control
                type='file'
                accept='image/*,application/pdf'
                onChange={(e) => setPoFile(e.target.files[0])}
              />
            </Form.Group>
          </>
        );
      case 'sales_return':
        return (
          <>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='selectCustomer'>
                  <Form.Label>Customer</Form.Label>
                  <Form.Select
                    value={customerId}
                    onChange={(e) => {
                      setCustomerId(e.target.value);
                      const c = customers.find(
                        (cc) => cc.id === parseInt(e.target.value)
                      );
                      handleCustomerSelect(c);
                    }}
                  >
                    <option value=''>Select Customer</option>
                    {customers.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId='invoiceNumber'>
                  <Form.Label>Invoice Number</Form.Label>
                  <Form.Control
                    type='text'
                    value={invoiceNumber}
                    onChange={(e) => setInvoiceNumber(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        );
      case 'payment_collection':
        return (
          <>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='selectCustomer'>
                  <Form.Label>Customer</Form.Label>
                  <Form.Select
                    value={customerId}
                    onChange={(e) => {
                      setCustomerId(e.target.value);
                      const c = customers.find(
                        (cc) => cc.id === parseInt(e.target.value)
                      );
                      handleCustomerSelect(c);
                    }}
                  >
                    <option value=''>Select Customer</option>
                    {customers.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId='pendingBalance'>
                  <Form.Label>Pending Balance</Form.Label>
                  <Form.Control
                    type='number'
                    value={pendingBalance}
                    onChange={(e) => setPendingBalance(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        );
      default:
        return null;
    }
  };

  const getEditOrderFields = () => {
    if (!currentOrder) return null;
    const onTextChange = (e) =>
      setCurrentOrder({ ...currentOrder, [e.target.name]: e.target.value });
    const onSelectChange = (e) =>
      setCurrentOrder({ ...currentOrder, [e.target.name]: e.target.value });
    switch (currentOrder.type) {
      case 'purchase_order':
      case 'purchase_return':
        return (
          <>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='selectVendor'>
                  <Form.Label>Vendor</Form.Label>
                  <Form.Select
                    name='vendor_id'
                    value={currentOrder.vendor_id || ''}
                    onChange={onSelectChange}
                  >
                    <option value=''>Select Vendor</option>
                    {vendors.map((v) => (
                      <option key={v.id} value={v.id}>
                        {v.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId='poNumber'>
                  <Form.Label>PO #</Form.Label>
                  <Form.Control
                    type='text'
                    name='po_number'
                    value={currentOrder.po_number || ''}
                    onChange={onTextChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className='mb-3' controlId='poValue'>
              <Form.Label>PO Value</Form.Label>
              <Form.Control
                type='number'
                name='return_value'
                value={currentOrder.return_value || ''}
                onChange={onTextChange}
              />
            </Form.Group>
          </>
        );
      case 'sales_return':
        return (
          <>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='selectCustomer'>
                  <Form.Label>Customer</Form.Label>
                  <Form.Select
                    name='customer_id'
                    value={currentOrder.customer_id || ''}
                    onChange={onSelectChange}
                  >
                    <option value=''>Select Customer</option>
                    {customers.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId='invoiceNumber'>
                  <Form.Label>Invoice Number</Form.Label>
                  <Form.Control
                    type='text'
                    name='invoice_number'
                    value={currentOrder.invoice_number || ''}
                    onChange={onTextChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        );
      case 'payment_collection':
        return (
          <>
            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='selectCustomer'>
                  <Form.Label>Customer</Form.Label>
                  <Form.Select
                    name='customer_id'
                    value={currentOrder.customer_id || ''}
                    onChange={onSelectChange}
                  >
                    <option value=''>Select Customer</option>
                    {customers.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId='pendingBalance'>
                  <Form.Label>Pending Balance</Form.Label>
                  <Form.Control
                    type='number'
                    name='pending_balance'
                    value={currentOrder.pending_balance || ''}
                    onChange={onTextChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        );
      default:
        return null;
    }
  };

  const formatDateTime = (dt) => {
    if (!dt) return 'N/A';
    try {
      const d = new Date(dt);
      const day = d.getDate().toString().padStart(2, '0');
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const year = d.getFullYear();
      const time = d.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      });
      return `${day}-${month}-${year}, ${time}`;
    } catch {
      return 'Invalid Date';
    }
  };

  const getOrderStatusVariant = (status) => {
    switch (status?.toLowerCase()) {
      case 'picked up':
      case 'delivered':
      case 'completed':
        return 'success';
      case 'pending':
        return 'warning';
      case 'in_transit':
      case 'assigned':
      case 'accepted':
        return 'primary';
      case 'cancelled':
      case 'rejected':
      case 'returned':
        return 'danger';
      default:
        return 'secondary';
    }
  };

  // --- START: UPDATED ADDRESS HELPER FUNCTIONS (Including nested object check) ---
  const getPickupAddress = (order) => {
    if (order.type === 'purchase_order') return order.vendor?.address || 'N/A';
    if (order.type === 'sales_order') return order.showroom?.address || 'N/A';
    if (order.type === 'purchase_return')
      return order.showroom?.address || 'N/A';
    // Assuming 'sales_return' pick up is from the customer
    if (order.type === 'sales_return') return order.customer?.address || 'N/A';
    return order.pickup_address || 'N/A'; // Fallback to raw pickup_address
  };

  const getDropAddress = (order) => {
    if (order.type === 'purchase_order')
      return order.showroom?.address || 'N/A';
    if (order.type === 'sales_order') return order.customer?.address || 'N/A';
    if (order.type === 'purchase_return') return order.vendor?.address || 'N/A';
    // Assuming 'sales_return' drop off is at the showroom
    if (order.type === 'sales_return') return order.showroom?.address || 'N/A';
    return order.delivery_address || 'N/A'; // Fallback to raw delivery_address
  };
  // --- END: UPDATED ADDRESS HELPER FUNCTIONS ---

  const getColumns = (tabKey) => {
    const baseColumns = [
      {
        name: '#',
        selector: (row, index) => index + 1,
        sortable: true,
        width: '50px',
        compact: true,
      },
      {
        name: 'Order No.',
        selector: (row) => row.order_number,
        sortable: true,
        cell: (row) => <strong>{row.order_number}</strong>,
        width: '100px',
        wrap: true,
      },
      {
        name: 'Type',
        selector: (row) => row.type,
        sortable: true,
        cell: (row) => {
          const typeText = row.type ? row.type.replace(/_/g, ' ') : '';
          if (!typeText) return '';
          const capitalizedType =
            typeText.charAt(0).toUpperCase() + typeText.slice(1).toLowerCase();
          return capitalizedType;
        },
        width: '120px',
        wrap: true,
      },
      {
        name: 'Showroom',
        selector: (row) => row.showroom_name,
        cell: (row) => (row.type ? row.type.replace(/_/g, ' ') : ''),
        sortable: true,
        width: '120px',
        wrap: true,
      },
      {
        name: 'Customer/Vendor',
        selector: (row) => row.customer_name || row.vendor_name,
        sortable: true,
        width: '140px',
        wrap: true,
      },
      // --- UPDATED CELL: Use custom content for Pickup/Drop ---
      {
        name: 'Pickup/Drop Address',
        selector: (row) => row.pickup_address,
        sortable: true,
        // Using the requested structure for the table cell
        cell: (row) => (
          <div>
            <div className='text-muted small mb-1'>
              <FaMapMarkerAlt className='text-primary me-1' size='10' />
              <strong>From:</strong> {getPickupAddress(row)}
            </div>
            <div className='text-muted small'>
              <FaCar className='text-success me-1' size='10' />
              <strong>To:</strong> {getDropAddress(row)}
            </div>
          </div>
        ),
        width: '300px',
        minWidth: '250px',
        wrap: true,
        style: {
          wordBreak: 'break-word',
        },
      },
      // The original separate columns are removed as they are combined above
    ];

    const dynamicColumns = [];
    // Add Driver column for all tabs except pending
    if (tabKey !== 'pending') {
      dynamicColumns.push({
        name: 'Driver',
        selector: (row) => row.driver_name,
        sortable: true,
        width: '120px',
        wrap: true,
      });
    }
    // Add Status column for all tabs including pending
    dynamicColumns.push({
      name: 'Status',
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => {
        const statusText = row.status
          ? row.status.replace(/_/g, ' ')
          : 'pending';
        const capitalizedStatus =
          statusText.charAt(0).toUpperCase() +
          statusText.slice(1).toLowerCase();
        return (
          <Badge bg={getOrderStatusVariant(row.status)}>
            {capitalizedStatus}
          </Badge>
        );
      },
      width: '120px',
      wrap: true,
    });

    const actionColumns = [
      {
        name: 'Created Date/Time',
        selector: (row) => row.created_at,
        sortable: true,
        cell: (row) => <small>{formatDateTime(row.created_at)}</small>,
        wrap: true,
        minWidth: '150px',
      },
      {
        name: 'Files',
        center: true,
        cell: (row) => {
          // Ensure attachments object exists and has proper structure
          if (!row.attachments || typeof row.attachments !== 'object') {
            return <span className='text-muted small'>No files</span>;
          }

          const podPhotos = Array.isArray(row.attachments.pod_photos)
            ? row.attachments.pod_photos
            : [];
          const voiceNotes = Array.isArray(row.attachments.voice_notes)
            ? row.attachments.voice_notes
            : [];
          const orderDocs = Array.isArray(row.attachments.order_docs)
            ? row.attachments.order_docs
            : [];
          const allFiles = [...podPhotos, ...voiceNotes, ...orderDocs];
          const filesWithUrl = allFiles.filter((f) => f?.url);

          return filesWithUrl.length > 0 ? (
            filesWithUrl.map((file, idx) => (
              <Button
                key={idx}
                variant='outline-info'
                size='sm'
                className='me-1 mb-1'
                onClick={() => handleOpenAttachment(file)}
              >
                <i className='fa fa-paperclip'></i>
              </Button>
            ))
          ) : (
            <span className='text-muted small'>No files</span>
          );
        },
        minWidth: '100px',
      },
      {
        name: 'Actions',
        center: true,
        cell: (row) => {
          const buttons = [
            <Button
              key='view'
              size='sm'
              variant='info'
              onClick={() => {
                setSelectedOrder(row);
                setShowOrderModal(true);
              }}
            >
              <FaEye />
            </Button>,
            row.driver_id &&
              row.status !== 'delivered' &&
              row.status !== 'completed' && (
                <Button
                  key='track'
                  size='sm'
                  variant='success'
                  onClick={() => handleTrackDriver(row)}
                >
                  <FaMapMarkerAlt />
                </Button>
              ),
            (tabKey === 'rejected' || tabKey === 'intransit' || tabKey === 'pending') && (
              <Button
                key='assign'
                size='sm'
                variant='primary'
                onClick={() => {
                  setSelectedOrderToAssign(row.id);
                  setSelectedDriver(row.driver_id || '');
                  setShowAssign(true);
                }}
              >
                <FaUserCheck />
              </Button>
            ),
            <Button
              key='edit'
              size='sm'
              variant='warning'
              onClick={() => {
                setCurrentOrder(row);
                setShowEditOrder(true);
              }}
            >
              <FaEdit />
            </Button>,
            <Button
              key='delete'
              size='sm'
              variant='danger'
              onClick={() => handleDeleteOrder(row.id)}
            >
              <FaTrash />
            </Button>,
          ].filter(Boolean);
          // Calculate grid columns based on actual number of buttons
          // If status is assigned, use 2 columns, otherwise calculate based on button count
          const buttonCount = buttons.length;
          const gridColumns =
            row.status?.toLowerCase() === 'assigned'
              ? 2
              : buttonCount > 3
              ? 4
              : buttonCount > 2
              ? 3
              : 2;
          return (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
                gap: '8px',
                width: '100%',
                maxWidth: '200px',
                margin: '0 auto',
                padding: '8px 0',
              }}
            >
              {buttons.map((button) =>
                React.cloneElement(button, {
                  style: {
                    ...button.props.style,
                    marginTop: '4px',
                    marginBottom: '4px',
                  },
                })
              )}
            </div>
          );
        },
        width: '200px',
      },
    ];

    // Excluding the redundant 'Pickup' and 'Drop' columns and inserting the new combined column
    const finalColumns = [
      baseColumns[0], // #
      baseColumns[1], // Order No.
      baseColumns[2], // Type
      baseColumns[3], // Showroom
      baseColumns[4], // Customer/Vendor
      baseColumns[5], // Pickup/Drop Address (Combined Column)
      ...dynamicColumns,
      ...actionColumns,
    ];

    // The original logic had separate Pickup/Drop columns, which were removed here to use the combined one.
    // If you need the combined column to replace the existing Pick/Drop:
    // You'd skip baseColumns[5] and baseColumns[6] which originally contained the single address.
    // Based on the provided original `getColumns`, baseColumns[5] and baseColumns[6] are the separated Pickup/Drop.
    // Let's refine the final columns structure to ensure the combined column replaces the two separate ones:

    const columnsWithoutSeparateAddresses = baseColumns.slice(0, 5); // Take up to Customer/Vendor

    // Find the index of the combined column defined above
    const combinedColumn = baseColumns.find(
      (col) => col.name === 'Pickup/Drop Address'
    );

    const refinedFinalColumns = [
      ...columnsWithoutSeparateAddresses,
      combinedColumn, // The new combined column
      ...dynamicColumns,
      ...actionColumns.slice(0, -1), // Excluding the last element of baseColumns (Drop) which is now combined
    ];

    return [
      {
        name: '#',
        selector: (row, index) => index + 1,
        sortable: true,
        width: '3vw',
        compact: true,
        grow: 0,
      },
      {
        name: 'Order No.',
        selector: (row) => row.order_number,
        sortable: true,
        cell: (row) => <strong>{row.order_number}</strong>,
        minWidth: '6vw',
        wrap: true,
        grow: 0,
      },
      {
        name: 'Type',
        selector: (row) => row.type,
        sortable: true,
        cell: (row) => {
          const typeText = row.type ? row.type.replace(/_/g, ' ') : '';
          if (!typeText) return '';
          const capitalizedType =
            typeText.charAt(0).toUpperCase() + typeText.slice(1).toLowerCase();
          return capitalizedType;
        },
        minWidth: '6vw',
        wrap: true,
        grow: 0,
      },
      {
        name: 'Showroom',
        selector: (row) => row.showroom_name,
        cell: (row) =>
          row.showroom_name ? row.showroom_name.replace(/_/g, ' ') : '',
        sortable: true,
        minWidth: '8vw',
        wrap: true,
        grow: 1,
      },
      {
        name: 'Customer/Vendor',
        selector: (row) => row.customer_name || row.vendor_name,
        sortable: true,
        minWidth: '12vw',
        wrap: true,
        grow: 1,
      },
      {
        name: 'Pickup/Drop Address',
        selector: (row) => row.pickup_address,
        sortable: false,
        cell: (
          row // <-- FIX: Added a wrapping fragment
        ) => (
          <>
            <div className='text-muted small mb-1'>
              <FaMapMarkerAlt className='text-primary me-1' size='10' />
              <strong>From:</strong> {getPickupAddress(row)}
            </div>
            <div className='text-muted small'>
              <FaCar className='text-success me-1' size='10' />
              <strong>To:</strong> {getDropAddress(row)}
            </div>
          </>
        ),
        minWidth: '20vw',
        width: '30vw',
        wrap: true,
        grow: 2,
        style: {
          wordBreak: 'break-word',
        },
      },
      ...dynamicColumns,
      {
        name: 'Created Date/Time',
        selector: (row) => row.created_at,
        sortable: true,
        cell: (row) => <small>{formatDateTime(row.created_at)}</small>,
        minWidth: '10vw',
        width: '10vw',
        wrap: true,
      },
      {
        name: 'Files',
        center: true,
        cell: (row) => {
          // Ensure attachments object exists and has proper structure
          if (!row.attachments || typeof row.attachments !== 'object') {
            return <span className='text-muted small'>No files</span>;
          }

          const podPhotos = Array.isArray(row.attachments.pod_photos)
            ? row.attachments.pod_photos
            : [];
          const voiceNotes = Array.isArray(row.attachments.voice_notes)
            ? row.attachments.voice_notes
            : [];
          const orderDocs = Array.isArray(row.attachments.order_docs)
            ? row.attachments.order_docs
            : [];
          const allFiles = [...podPhotos, ...voiceNotes, ...orderDocs];
          const filesWithUrl = allFiles.filter((f) => f?.url);

          return filesWithUrl.length > 0 ? (
            filesWithUrl.map((file, idx) => (
              <Button
                key={idx}
                variant='outline-info'
                size='sm'
                className='me-1 mb-1'
                onClick={() => handleOpenAttachment(file)}
              >
                <i className='fa fa-paperclip'></i>
              </Button>
            ))
          ) : (
            <span className='text-muted small'>No files</span>
          );
        },
        minWidth: '6vw',
        width: '6vw',
      },
      {
        name: 'Actions',
        center: true,
        cell: (row) => {
          const buttons = [
            <Button
              key='view'
              size='sm'
              variant='info'
              onClick={() => {
                setSelectedOrder(row);
                setShowOrderModal(true);
              }}
            >
              <FaEye />
            </Button>,
            row.driver_id &&
              row.status !== 'delivered' &&
              row.status !== 'completed' && (
                <Button
                  key='track'
                  size='sm'
                  variant='success'
                  onClick={() => handleTrackDriver(row)}
                >
                  <FaMapMarkerAlt />
                </Button>
              ),
            (tabKey === 'pending' ||
              tabKey === 'rejected' ||
              tabKey === 'intransit') && (
              <Button
                key='assign'
                size='sm'
                variant='primary'
                onClick={() => {
                  setSelectedOrderToAssign(row.id);
                  setSelectedDriver(row.driver_id || '');
                  setShowAssign(true);
                }}
              >
                <FaUserCheck />
              </Button>
            ),
            (tabKey === 'pending' || tabKey === 'assigned') && (
              <Button
                key='edit'
                size='sm'
                variant='warning'
                onClick={() => {
                  setCurrentOrder(row);
                  setShowEditOrder(true);
                }}
              >
                <FaEdit />
              </Button>
            ),
            <Button
              key='delete'
              size='sm'
              variant='danger'
              onClick={() => handleDeleteOrder(row.id)}
            >
              <FaTrash />
            </Button>,
          ].filter(Boolean); // Remove falsy values (conditional buttons)
          // If status is assigned, use 2 columns, otherwise calculate based on button count
          const buttonCount = buttons.length;
          const gridColumns =
            row.status?.toLowerCase() === 'assigned'
              ? 2
              : buttonCount > 4
              ? 4
              : buttonCount > 2
              ? 3
              : 2;

          return (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${gridColumns}, 1fr)`,
                gap: '8px',
                width: '100%',
                maxWidth: '200px',
                margin: '0 auto',
                padding: '8px 0',
              }}
            >
              {buttons.map((button) =>
                React.cloneElement(button, {
                  style: {
                    ...button.props.style,
                    marginTop: '4px',
                    marginBottom: '4px',
                  },
                })
              )}
            </div>
          );
        },
        grow: 0,
        width: '10vw',
      },
    ];
  };

  // --- ADDED: Custom Loading Component for DataTable ---
  const CustomLoadingIndicator = (
    <div className='p-3 text-center'>
      <Spinner
        animation='border'
        role='status'
        className='me-2'
        variant='primary'
      />
      <span className='text-primary'>Loading Orders...</span>
    </div>
  );

  // --- ADDED: Custom No Data Component for DataTable ---
  const CustomNoDataComponent = (
    <div className='p-4 text-center text-muted'>
      <FaBoxOpen className='mb-2' size={32} />
      <h5 className='mt-2'>No Orders Found</h5>
      <p className='mb-0'>
        There are currently no orders in this list or matching your search
        criteria.
      </p>
    </div>
  );
  // -----------------------------------------------------

  const ViewOrderModal = () => {
    if (!viewOrder) return null;

    return (
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size='lg'
        centered
        className='custom-modal'
      >
        <Modal.Header closeButton className='border-0 pb-0'>
          <div className='d-flex justify-content-between align-items-center w-100'>
            <div>
              <small
                className='text-muted'
                style={{ fontSize: '1.1rem', fontWeight: '600' }}
              >
                Order No: #{viewOrder.order_number}
              </small>
            </div>
            <h4 className='mb-0 flex-grow-1 text-center'>Order Details</h4>
            <div style={{ width: '30px' }}></div>{' '}
            {/* Keeps title perfectly centered */}
          </div>
        </Modal.Header>
        <Modal.Body className='pt-2'>
          <div className='order-detail-card p-4 rounded shadow-sm bg-light'>
            <Row className='g-3'>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Type:</strong>{' '}
                  <span className='text-capitalize'>
                    {viewOrder.type.replace(/_/g, ' ')}
                  </span>
                </div>
              </Col>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Customer/Vendor:</strong>{' '}
                  {viewOrder.customer_name || viewOrder.vendor_name}
                </div>
              </Col>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Pickup:</strong>
                  <div className='mt-1'>
                    <small>{getPickupAddress(viewOrder)}</small>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Drop:</strong>
                  <div className='mt-1'>
                    <small>{getDropAddress(viewOrder)}</small>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Driver:</strong> {viewOrder.driver_name}
                </div>
              </Col>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Status:</strong>
                  <Badge
                    bg={getOrderStatusVariant(viewOrder.status)}
                    className='ms-2'
                  >
                    {viewOrder.status.replace(/_/g, ' ')}
                  </Badge>
                </div>
              </Col>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Created:</strong>{' '}
                  {formatDateTime(viewOrder.created_at)}
                </div>
              </Col>
              <Col md={6}>
                <div className='detail-item'>
                  <strong>Updated:</strong>{' '}
                  {formatDateTime(viewOrder.updated_at)}
                </div>
              </Col>
              <Col md={12}>
                <div className='detail-item'>
                  <strong>Remarks:</strong> {viewOrder.notes || '—'}
                </div>
              </Col>
              <Col md={12}>
                <div className='detail-item'>
                  <strong>Attachments:</strong>
                  {(() => {
                    const podPhotos = Array.isArray(
                      viewOrder.attachments?.pod_photos
                    )
                      ? viewOrder.attachments.pod_photos
                      : [];
                    const voiceNotes = Array.isArray(
                      viewOrder.attachments?.voice_notes
                    )
                      ? viewOrder.attachments.voice_notes
                      : [];
                    const orderDocs = Array.isArray(
                      viewOrder.attachments?.order_docs
                    )
                      ? viewOrder.attachments.order_docs
                      : [];
                    const allFiles = [
                      ...podPhotos,
                      ...voiceNotes,
                      ...orderDocs,
                    ];
                    const filesWithUrl = allFiles.filter((f) => f?.url);

                    return filesWithUrl.length > 0 ? (
                      <div className='d-flex flex-wrap gap-2 mt-2'>
                        {filesWithUrl.map((file, idx) => (
                          <Button
                            key={idx}
                            variant='outline-primary'
                            size='sm'
                            onClick={() => handleOpenAttachment(file)}
                            className='d-flex align-items-center gap-1'
                          >
                            <FaBoxOpen />
                            {file.name || `File ${idx + 1}`}
                          </Button>
                        ))}
                      </div>
                    ) : (
                      <span className='text-muted ms-2'>No files</span>
                    );
                  })()}
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer className='border-0 justify-content-center'>
          <Button
            size='sm'
            variant='secondary'
            onClick={() => setShowViewModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <div className='border p-2 rounded' style={{ background: '#fff' }}>
      <Container fluid className='p-4'>
        <Modal
          show={messageModal.show}
          onHide={handleCloseMessageModal}
          centered
          size='md'
        >
          <Modal.Body
            className='py-4 text-center'
            style={{
              backgroundColor: '#fff',
              color: '#1f1f1f',
              borderRadius: '15px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            }}
          >
            <div className='mb-3'>
              {messageModal.title === 'Success' ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='60'
                  height='60'
                  fill='green'
                  className='bi bi-check-circle-fill'
                  viewBox='0 0 16 16'
                >
                  <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.97 11.03a.75.75 0 0 0 1.08 0l3.992-3.992a.75.75 0 0 0-1.08-1.04L7.5 9.439 5.53 7.47a.75.75 0 0 0-1.08 1.04l2.52 2.52z' />
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='60'
                  height='60'
                  fill='red'
                  className='bi bi-x-circle-fill'
                  viewBox='0 0 16 16'
                >
                  <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.646 4.646a.5.5 0 0 0 0 .708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646a.5.5.5 0 0 0-.708 0z' />
                </svg>
              )}
            </div>
            <h5 className='mb-2'>{messageModal.title}</h5>
            <p>{messageModal.body}</p>
            <Button
              size='sm'
              variant={messageModal.title === 'Success' ? 'success' : 'danger'}
              style={{ width: '100%' }}
              onClick={handleCloseMessageModal}
            >
              Close
            </Button>
          </Modal.Body>
        </Modal>

        <h3 style={{ textAlign: 'center' }}>Order Management</h3>
        <div className='row justify-content-between align-items-center mt-3'>
          <div className='col-md-9 col-lg-9 col-sm-12 align-items-center py-3 gap-2'>
            <Row className='g-2'>
              <Col xs='auto'>
                <InputGroup style={{ width: '300px' }}>
                  <InputGroup.Text>
                    <i className='fa fa-search'></i>
                  </InputGroup.Text>
                  <Form.Control
                    type='text'
                    placeholder='Search Orders'
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </InputGroup>
              </Col>
            </Row>
          </div>
          <div className='col-md-3 col-lg-3 col-sm-12 text-end d-flex justify-content-end gap-2'>
            {/* Export to Excel Button */}

            <Button
              variant='primary'
              size='sm'
              onClick={() => setShowNewOrder(true)}
            >
              <i className='fa fa-plus'></i> New Order
            </Button>
            <Button variant='success' size='sm' onClick={exportToExcel}>
              <FaFileExport /> Export to Excel
            </Button>
          </div>
        </div>

        <Tabs
          activeKey={activeTab}
          onSelect={(key) => {
            // Always update activeTab, even if same - this ensures proper state reset
            // The useEffect will handle fetching with proper status
            setActiveTab(key);
          }}
          defaultActiveKey='pending'
          id='fill-tab-example'
          className='mb-3'
          fill
          style={{ background: '#dbe6ff' }}
        >
          {[
            'pending',
            'assigned',
            'accepted',
            'intransit',
            'completed',
            'rejected',
            'returned',
            'history',
          ].map((tabKey) => {
            const columns = getColumns(tabKey);
            // For server-side pagination, only show data for the active tab
            // The server already filters by status, so we only need to apply search filter
            // and handle special cases that require additional client-side filtering
            let data = [];
            if (tabKey === activeTab) {
              // Server already filtered by status for most tabs
              // Apply search filter (filteredOrders already has search applied)
              // For simple status matches, server already filtered, so use filteredOrders directly
              // Only apply additional filtering for special cases
              if (tabKey === 'pending') {
                // Pending tab: status 'pending' OR no driver_id
                // Server fetches with status='pending', but we also need orders without driver_id
                // So we filter client-side to include both
                data = filteredOrders.filter(
                  (order) => order.status === 'pending' || !order.driver_id
                );
              } else if (tabKey === 'assigned') {
                // Assigned tab: status 'assigned' AND has driver_id
                // Server fetches with status='assigned', but we need to ensure driver_id exists
                // Also ensure status is exactly 'assigned' to prevent other statuses from showing
                data = filteredOrders.filter(
                  (order) =>
                    order.status?.toLowerCase() === 'assigned' &&
                    order.driver_id
                );
              } else if (tabKey === 'rejected') {
                // Rejected tab: only show orders with status 'rejected'
                // Double-check to ensure no other statuses slip through
                data = filteredOrders.filter(
                  (order) => order.status?.toLowerCase() === 'rejected'
                );
              } else if (tabKey === 'intransit') {
                // Intransit tab: status 'in_transit' OR 'picked_up'
                // Server fetches with status='in_transit', but we also include 'picked_up'
                data = filteredOrders.filter(
                  (order) =>
                    order.status?.toLowerCase() === 'in_transit' ||
                    order.status?.toLowerCase() === 'picked_up'
                );
              } else if (tabKey === 'returned') {
                // Returned tab: only show orders with status 'returned'
                // Double-check to ensure no other statuses slip through
                data = filteredOrders.filter(
                  (order) => order.status?.toLowerCase() === 'returned'
                );
              } else {
                // For other tabs (accepted, completed, history),
                // server already filtered correctly, so use filteredOrders directly
                // No additional filtering needed - server already did it
                data = filteredOrders;
              }

              // Debug: Log data counts
              console.log(`Tab ${tabKey}:`, {
                totalOrders: orders.length,
                afterSearchFilter: filteredOrders.length,
                afterTabFilter: data.length,
                totalRows: totalRows,
                ordersWithStatus:
                  tabKey === 'returned'
                    ? orders.filter(
                        (o) => o.status?.toLowerCase() === 'returned'
                      ).length
                    : 'N/A',
                sampleReturnedOrders:
                  tabKey === 'returned'
                    ? orders
                        .filter((o) => o.status?.toLowerCase() === 'returned')
                        .slice(0, 3)
                        .map((o) => ({
                          id: o.id,
                          status: o.status,
                          order_number: o.order_number,
                          po_number: o.po_number,
                        }))
                    : 'N/A',
              });

              // Track if we've ever had data for this tab
              if (data.length > 0) {
                hasDataRef.current[tabKey] = true;
              }
            }

            // Determine if we should show loading overlay
            // Show loading overlay only during initial load (when loading is true)
            // When loading more pages, if we have data displayed or have ever had data, never show overlay
            // Only show overlay when loading more if we have no data displayed and never had data
            const hasEverHadData = hasDataRef.current[tabKey] || false;
            const hasOrdersInState = orders.length > 0;
            const hasDataDisplayed = data.length > 0;
            const shouldShowLoading =
              loading ||
              (isLoadingMore &&
                !hasDataDisplayed &&
                !hasEverHadData &&
                !hasOrdersInState);

            // Determine if we should show "no data" message
            // Only show if: not loading AND not loading more AND no filtered data
            const shouldShowNoData =
              !loading && !isLoadingMore && data.length === 0;

            return (
              <Tab
                eventKey={tabKey}
                title={tabKey.charAt(0).toUpperCase() + tabKey.slice(1)}
                key={tabKey}
              >
                {tabKey === activeTab && (
                  <div
                    ref={scrollContainerRef}
                    style={{
                      height: '50vh',
                      display: 'flex',
                      flexDirection: 'column',
                      overflow: 'hidden',
                    }}
                  >
                    {/* Count Display */}
                    {data.length > 0 && (
                      <div
                        className='text-end mt-0'
                        style={{
                          backgroundColor: '#f8f9fa',
                          borderBottom: '1px solid #dee2e6',
                          flexShrink: 0,
                          padding: '4px 8px',
                        }}
                      >
                        <small className='text-muted'>
                          Showing <strong>{1}</strong> to{' '}
                          <strong>{data.length}</strong> out of{' '}
                          <strong>{data.length}</strong> orders
                        </small>
                      </div>
                    )}
                    <div style={{ flex: 1, overflow: 'hidden', minHeight: 0 }}>
                      <DataTable
                        columns={columns}
                        data={data}
                        pagination={false}
                        highlightOnHover
                        striped
                        dense
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight='45vh'
                        noTableHead={false}
                        customStyles={{
                          table: {
                            style: {
                              tableLayout: 'auto',
                              width: '100%',
                              minWidth: '100%',
                            },
                          },
                          tableWrapper: {
                            style: {
                              width: '100%',
                              height: '100%',
                              overflowX: 'auto',
                              overflowY: 'auto',
                              position: 'relative',
                            },
                          },
                          headRow: {
                            style: {
                              backgroundColor: '#cce5ff',
                              color: '#004085',
                              borderBottomStyle: 'solid',
                              borderBottomWidth: '2px',
                              borderBottomColor: '#dee2e6',
                            },
                          },
                          headCells: {
                            style: {
                              backgroundColor: '#cce5ff',
                              color: '#004085',
                              fontSize: '14px',
                              fontWeight: '600',
                              paddingLeft: '8px',
                              paddingRight: '8px',
                            },
                          },
                          cells: {
                            style: {
                              wordBreak: 'break-word',
                              whiteSpace: 'normal',
                            },
                          },
                        }}
                        // --- LOADING/NO DATA PROPS ---
                        // Show loading overlay if we should show loading
                        progressPending={shouldShowLoading}
                        progressComponent={CustomLoadingIndicator}
                        // Only show "no data" component if we should show no data
                        noDataComponent={
                          shouldShowNoData ? CustomNoDataComponent : null
                        }
                        // -----------------------------
                      />
                    </div>
                  </div>
                )}
              </Tab>
            );
          })}
        </Tabs>

        <ViewOrderModal />

        <Modal
          size='lg'
          show={showNewOrder}
          onHide={() => setShowNewOrder(false)}
          backdrop='static'
        >
          <Modal.Header closeButton>
            <Modal.Title>New Order</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmitOrder}>
              <Row className='mb-3'>
                <Col md={6}>
                  <Form.Group controlId='orderType'>
                    <Form.Label>Order Type</Form.Label>
                    <Form.Select
                      value={orderType}
                      onChange={(e) => {
                        setOrderType(e.target.value);
                        setVendorId('');
                        setCustomerId('');
                        setPoNumber('');
                        setInvoiceNumber('');
                        setPendingBalance('');
                        setPoValue('');
                        setRemarks('');
                        setShowroom('');
                        setVendorAddress('');
                        setDropAddress('');
                        setPoFile(null);
                        setNewFromCoords(null);
                        setNewDropCoords(null);
                        setPickupLat('');
                        setPickupLng('');
                        setDeliveryLat('');
                        setDeliveryLng('');
                        setSelectedPoId('');
                      }}
                      required
                    >
                      <option value=''>Select Order Type</option>
                      <option value='purchase_order'>Purchase Order</option>
                      <option value='sales_return'>Sales Return</option>
                      <option value='purchase_return'>Purchase Return</option>
                      {/* <option value="payment_collection">Payment Collection</option> */}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId='assignDriver'>
                    <Form.Label>Assign Driver</Form.Label>
                    <Form.Select
                      value={driverId}
                      onChange={(e) => {setDriverId(e.target.value)
                        setDropAddress('')
                      }}
                      required
                    >
                      <option value=''>Select Driver</option>
                      {drivers.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              {getNewOrderFields()}

              {orderType && (
                <Form.Group controlId='selectShowroom' className='mb-3'>
                  <Form.Label>Showroom</Form.Label>
                  <Form.Select
                    value={showroom}
                    onChange={(e) => {
                      setShowroom(e.target.value);
                      const selectedShowroom = showrooms.find(
                        (s) => s.id === parseInt(e.target.value)
                      );
                      handleShowroomSelect(selectedShowroom);
                    }}
                  >
                    <option value=''>Select Showroom</option>
                    {filteredShowroomsForDriver.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
              {orderType && (
                <Form.Group className='mb-3' controlId='pickupAddress'>
                  <Form.Label>Pick-up Location</Form.Label>
                  <Row>
                    <Col md={9}>
                      <Form.Control
                        as='textarea'
                        rows={2}
                        placeholder='Enter pickup address'
                        name='vendorAddress'
                        value={vendorAddress}
                        onChange={(e) => setVendorAddress(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                </Form.Group>
              )}
              {orderType && (
                <Form.Group className='mb-3' controlId='dropLocation'>
                  <Form.Label>Drop Location</Form.Label>
                  <Row>
                    <Col md={9}>
                      <Form.Control
                        as='textarea'
                        rows={2}
                        placeholder='Enter drop address'
                        name='dropAddress'
                        value={dropAddress}
                        onChange={(e) => setDropAddress(e.target.value)}
                        required
                      />
                    </Col>
                  </Row>
                </Form.Group>
              )}
              {orderType && (
                <Form.Group className='mb-3' controlId='remarks'>
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={2}
                    placeholder='Enter remarks'
                    name='remarks'
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </Form.Group>
              )}
              <div className='d-flex justify-content-end'>
                <Button
                  size='sm'
                  variant='secondary'
                  onClick={() => setShowNewOrder(false)}
                  className='me-2'
                >
                  Cancel
                </Button>
                <Button
                  size='sm'
                  type='submit'
                  variant='primary'
                  disabled={!orderType}
                >
                  Create Order
                </Button>
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        <Modal show={showAssign} onHide={() => setShowAssign(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Assign Driver</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Select
              value={selectedDriver}
              onChange={(e) => setSelectedDriver(e.target.value)}
            >
              <option value=''>Select Driver</option>
              {Array.isArray(drivers) && drivers.length > 0 ? (
                drivers.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name || `Driver #${d.id}`}
                  </option>
                ))
              ) : (
                <option value='' disabled>
                  No drivers available
                </option>
              )}
            </Form.Select>
          </Modal.Body>
          <Modal.Footer>
            <Button
              size='sm'
              variant='secondary'
              onClick={() => setShowAssign(false)}
            >
              Close
            </Button>
            <Button
              size='sm'
              variant='primary'
              onClick={async () => {
                try {
                  if (!selectedDriver || !selectedOrderToAssign) {
                    showMessageModal('Warning', 'Please select a driver.');
                    return;
                  }
                  const res = await authAxios.post(
                    `/orders/${selectedOrderToAssign}/assign-driver`,
                    {
                      driver_id: Number(selectedDriver),
                    }
                  );
                  const assignedStatus =
                    res.data?.data?.status || res.data?.status || 'assigned';
                  showMessageModal(
                    'Success',
                    `Driver assigned successfully! Status: ${assignedStatus}`
                  );
                  // Reset and reload orders from the beginning
                  setOrders([]);
                  setCurrentPage(1);
                  setHasMore(true);
                  const statusFilter = getStatusFilterForTab(activeTab);
                  fetchAllOrdersSequentially(statusFilter, activeTab);
                  setSelectedDriver('');
                  setSelectedOrderToAssign(null);
                  setShowAssign(false);
                } catch (err) {
                  const msg = err.response?.data?.error || 'Unknown error';
                  showMessageModal('Error', `Failed to assign driver: ${msg}`);
                }
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size='lg'
          show={showEditOrder}
          onHide={() => setShowEditOrder(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Order #{currentOrder?.id}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {currentOrder && (
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleEditSubmit(currentOrder, poFile);
                }}
              >
                <Row className='mb-3'>
                  <Col md={6}>
                    <Form.Group controlId='assignDriver'>
                      <Form.Label>Assign Driver</Form.Label>
                      <Form.Select
                        name='driver_id'
                        value={currentOrder.driver_id || ''}
                        onChange={(e) => {
                          const newDriverId = e.target.value;
                          const updatedOrder = {
                            ...currentOrder,
                            driver_id: newDriverId,
                          };
                          if (newDriverId) {
                            const selectedDriverObj = drivers.find(
                              (d) => d.id === parseInt(newDriverId)
                            );
                            if (selectedDriverObj) {
                              let driverShowroomIds = [];
                              if (
                                Array.isArray(selectedDriverObj.showroom_id)
                              ) {
                                driverShowroomIds =
                                  selectedDriverObj.showroom_id;
                              } else if (
                                typeof selectedDriverObj.showroom_id ===
                                'string'
                              ) {
                                try {
                                  const parsedIds = JSON.parse(
                                    selectedDriverObj.showroom_id
                                  );
                                  if (Array.isArray(parsedIds)) {
                                    driverShowroomIds = parsedIds;
                                  }
                                } catch (e) {
                                  console.error(
                                    'Failed to parse showroom_id string:',
                                    e
                                  );
                                }
                              } else if (
                                typeof selectedDriverObj.showroom_id ===
                                'number'
                              ) {
                                driverShowroomIds = [
                                  selectedDriverObj.showroom_id,
                                ];
                              }
                              const numericDriverShowroomIds =
                                driverShowroomIds.map(Number);

                              // Automatically set showroom based on driver
                              if (numericDriverShowroomIds.length > 0) {
                                // If current showroom belongs to the new driver, keep it
                                if (
                                  currentOrder.showroom_id &&
                                  numericDriverShowroomIds.includes(
                                    parseInt(currentOrder.showroom_id)
                                  )
                                ) {
                                  // Keep the current showroom
                                  updatedOrder.showroom_id =
                                    currentOrder.showroom_id;
                                } else {
                                  // Set to the first showroom of the driver
                                  updatedOrder.showroom_id =
                                    numericDriverShowroomIds[0].toString();
                                }
                              } else {
                                // Driver has no showrooms, clear it
                                updatedOrder.showroom_id = '';
                              }
                            }
                          } else {
                            // No driver selected, clear showroom
                            updatedOrder.showroom_id = '';
                          }
                          setCurrentOrder(updatedOrder);
                        }}
                      >
                        <option value=''>Select Driver</option>
                        {drivers.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
                {getEditOrderFields()}
                <Form.Group controlId='editShowroom' className='mb-3'>
                  <Form.Label>Showroom</Form.Label>
                  <Form.Select
                    name='showroom_id'
                    value={currentOrder.showroom_id || ''}
                    onChange={(e) =>
                      setCurrentOrder({
                        ...currentOrder,
                        showroom_id: e.target.value,
                      })
                    }
                  >
                    <option value=''>Select Showroom</option>
                    {(currentOrder.driver_id
                      ? filteredShowroomsForEdit
                      : showrooms
                    ).map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className='mb-3' controlId='vendorAddress'>
                  <Form.Label>From (Vendor Address)</Form.Label>
                  <Row>
                    <Col md={9}>
                      <Form.Control
                        as='textarea'
                        rows={2}
                        name='pickup_address'
                        value={currentOrder.pickup_address || ''}
                        onChange={(e) =>
                          setCurrentOrder({
                            ...currentOrder,
                            pickup_address: e.target.value,
                          })
                        }
                      />
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className='mb-3' controlId='dropLocation'>
                  <Form.Label>Drop Location</Form.Label>
                  <Row>
                    <Col md={9}>
                      <Form.Control
                        as='textarea'
                        rows={2}
                        name='delivery_address'
                        value={currentOrder.delivery_address || ''}
                        onChange={(e) =>
                          setCurrentOrder({
                            ...currentOrder,
                            delivery_address: e.target.value,
                          })
                        }
                      />
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className='mb-3' controlId='remarks'>
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={2}
                    name='remarks'
                    value={currentOrder.notes || ''}
                    onChange={(e) =>
                      setCurrentOrder({
                        ...currentOrder,
                        remarks: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Button size='sm' variant='primary' type='submit'>
                  Update Order
                </Button>
              </Form>
            )}
          </Modal.Body>
        </Modal>
        <AdminOrderDetailsModal
          show={showOrderModal}
          order={selectedOrder}
          handleClose={handleCloseOrderModal}
        />

        <OrderTracking
          show={showOrderTrackingModal}
          handleClose={handleCloseTrackModal}
          driverId={trackModalOrder?.driver_id}
          order={trackModalOrder}
        />
      </Container>
    </div>
  );
};

export default AdminOrders;